var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "ma-n1",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "outlined": "",
      "width": "150",
      "color": _vm.form.isGranted == true ? 'primary' : 'grey-d'
    },
    on: {
      "click": function ($event) {
        return _vm.emit(true);
      }
    }
  }, [_c('span', {
    class: {
      'grey--text': _vm.form.isGranted != true
    }
  }, [_vm._v(" 승인 ")])])], 1), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "outlined": "",
      "width": "150",
      "color": _vm.form.isGranted != true ? 'primary' : 'grey-d'
    },
    on: {
      "click": function ($event) {
        return _vm.emit(false);
      }
    }
  }, [_c('span', {
    class: {
      'grey--text': _vm.form.isGranted == true
    }
  }, [_vm._v(" 거부 ")])])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }